export default "__VITE_ASSET__c272be2d__"